import { IconButton, Tooltip } from '@mui/material'
import { copyToClipboard } from '@playground/utils/helpers'
import { Check as CheckIcon, Copy as CopyIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

const CONFIRMATION_MS = 1500

type CopyCodeButtonProps = {
  /** Copied verbatim — the canonical code, not the hyphenated display form. */
  code: string
  /** Names what is copied. A URL is not "code". */
  label?: string
}

const CopyCodeButton = ({ code, label = 'Copy code' }: CopyCodeButtonProps) => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const timer = setTimeout(() => setCopied(false), CONFIRMATION_MS)
    return () => clearTimeout(timer)
  }, [copied])

  const handleCopy = (): void => {
    copyToClipboard(code)
      .then(() => setCopied(true))
      .catch(() => setCopied(false))
  }

  return (
    <Tooltip title={copied ? 'Copied' : label}>
      <IconButton size="small" onClick={handleCopy} aria-label={label}>
        {copied ? (
          <CheckIcon className="size-4" />
        ) : (
          <CopyIcon className="size-4" />
        )}
      </IconButton>
    </Tooltip>
  )
}

export default CopyCodeButton
